var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 20V25H36.9997V28.3333H31.9997V33.3333H28.6663V28.3333H23.6663V25H28.6663V20H31.9997ZM32.013 0C32.9263 0 33.6663 0.741667 33.6663 1.655V16.6667H30.333V3.33333H3.66634V26.665L20.333 10L25.333 15V19.715L20.333 14.715L8.37801 26.6667H20.333V30H1.98634C1.5477 29.9996 1.12717 29.825 0.817157 29.5147C0.507145 29.2043 0.333008 28.7836 0.333008 28.345V1.655C0.336058 1.2173 0.511175 0.798362 0.820529 0.488696C1.12988 0.17903 1.54864 0.00349108 1.98634 0H32.013ZM10.333 6.66667C11.2171 6.66667 12.0649 7.01786 12.69 7.64298C13.3152 8.2681 13.6663 9.11594 13.6663 10C13.6663 10.8841 13.3152 11.7319 12.69 12.357C12.0649 12.9821 11.2171 13.3333 10.333 13.3333C9.44895 13.3333 8.60111 12.9821 7.97599 12.357C7.35086 11.7319 6.99967 10.8841 6.99967 10C6.99967 9.11594 7.35086 8.2681 7.97599 7.64298C8.60111 7.01786 9.44895 6.66667 10.333 6.66667Z",
    fill: "#09121F",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcn);
export default __webpack_public_path__ + "static/media/up-icn.021d691b472c8af2e3d1cf1f0cb23ab5.svg";
export { ForwardRef as ReactComponent };